const getVersionData = function() {
	let versionData;
	try {
		versionData = require('../version.json');
	}
	catch {
		// No hay datos, retornar undefined
	}
	return versionData;
};

module.exports = {
	getVersionData,
};